import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Vento blovas, mi malverdas, <br/>
        Kaj foliojn miajn perdas, <br/>
        Dismetitajn sur vasta ter’, <br/>
        Dum mi mortos pro senesper’.
      </p>
      
      <p class="poem-block mb-3">
        Semoj de la amo mia flugos kun la forta vent’, <br/>
        Semoj de la amo mia kreskos ie en anim’. <br/>
        Semoj de esperoj miaj, plumoj de amara sent’, <br/>
        Semoj de aspiroj miaj tra amaro kreskos sor.
      </p>
      
      <p class="poem-block mb-3">
        Post somer’ rikolto venos, <br/>
        Vivu plene, falĉu grenon. <br/>
        Kaj ne gravas, ke degelis mi: <br/>
        Miaj kantoj restis ja por vi.
      </p>
      
      <p class="poem-block mb-3">
        Mortas herboj, mortas flor’ – temp’ funebra de aùtun’, <br/>
        De angoro nigra temp’ – sed jubilas la printemp’! <br/>
        Sen mi kantos la april’ en ĉiela blua bril’, <br/>
        Nefinita mia kant’ sprosos en printempa plant’.
      </p>
      
      <p class="poem-block mb-3">
        Jam malverda, perdis ĉion mi, <br/>
        Koron al ĉielo ligas mi. <br/>
        Kaj se iu ekmemoros min, <br/>
        Fridan akvon de espero trinkos li sen fin’.  
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Mi malverdas…'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['O4pQcL4uUQc'],
    itemTranslator: translator.esp
  }
}

export default item;